import queryString from 'query-string';
import Cookies from 'js-cookie';

import { removeQueryParams } from '../utils';

const AUTH_RETRY = 'mypage-auth-retry';
const RETRY_TIMESTAMP = 'mypage-retry-ts';
const RETRY_MAX_NUM = 5;
const JWT_TOKEN = 'mypage-sid';
const PULSE_COOKIE = '_pulse2data';
export const STATE_DATA_KEY = 'auth_state_data';
const PULSE_JWE_INDEX = 4;
const ONE_MINUTE_IN_MS = 60 * 1000;

const getRetryCounter = () => parseInt(localStorage.getItem(AUTH_RETRY) || 0, 10);
const getRetryTimestamp = () => parseInt(localStorage.getItem(RETRY_TIMESTAMP) || 0, 10);
const getQueryParam = (key) => {
    const codes = queryString.parse(window.location.search)[key] || [];
    const codesArray = Array.isArray(codes) ? codes : [codes];
    return codesArray.pop();
};

export const isQueryParamPresent = key => !!queryString.parse(window.location.search)[key];

export const canRetry = () => {
    if ((+Date.now() - getRetryTimestamp()) > ONE_MINUTE_IN_MS) {
        localStorage.removeItem(AUTH_RETRY);
    }
    return getRetryCounter() < RETRY_MAX_NUM;
};

export const incrementRetry = () => {
    localStorage.setItem(AUTH_RETRY, getRetryCounter() + 1);
    localStorage.setItem(RETRY_TIMESTAMP, +Date.now());
};

export const cleanRetry = () => {
    localStorage.removeItem(AUTH_RETRY);
    localStorage.removeItem(RETRY_TIMESTAMP);
};

export const getSchAccCode = () => getQueryParam('code');

export const getSchAccState = () => getQueryParam('state');

export const decodeState = (state) => {
    try {
        return JSON.parse(window.atob(state));
    } catch (e) {
        return null;
    }
};

export const getPulseCode = () => getQueryParam('pulseCode');

export const setJWT = (jwt) => {
    localStorage.setItem(JWT_TOKEN, jwt);
};

export const getJWT = () => localStorage.getItem(JWT_TOKEN);

export const removeJWT = () => localStorage.removeItem(JWT_TOKEN);

export const hasPulseJWE = () => !!Cookies.get(PULSE_COOKIE);

export const getPulseJWE = () => {
    const pulseData = Cookies.get(PULSE_COOKIE)?.split(',');

    return pulseData ? pulseData[PULSE_JWE_INDEX] : null;
};

export const setAuthStateData = (toStoreInState) => {
    const loginNonce = Math.random().toString(16);
    const state = window.btoa(JSON.stringify({
        ...toStoreInState,
        loginNonce,
    }));

    localStorage.setItem(
        STATE_DATA_KEY,
        state
    );

    return state;
};

export const getAuthState = () => localStorage.getItem(STATE_DATA_KEY);

export const removeAuthStateData = () => localStorage.removeItem(STATE_DATA_KEY);

const currentPath = () => window.location.pathname;

const getSearchWithoutParams = (params) => {
    const updatedUrl = removeQueryParams(params)(window.location.href, true);
    const url = new URL(updatedUrl);

    return url.search;
};

/**
 * Resets the authentication state and sets redirect location.
 // * @param {string} [pathname=currentPath()] - The pathname to set as redirect location. Defaults to current path.
 * @param {Object|undefined} redirectLocation - The redirect location object containing pathname and search parameters.
 * @returns {Object} Updated auth state data with new redirect location object containing pathname and search parameters
 * (excluding 'pulseCode' from search query).
 */
export const resetAuthStateRedirectLocation = redirectLocation => setAuthStateData({
    redirectLocation: {
        pathname: redirectLocation?.pathname || currentPath(),
        search: redirectLocation?.search || getSearchWithoutParams(['pulseCode', 'code', 'state']),
    },
});

export const orInitializer = (...args) => actions =>
    actions.some(action => (action[0] ? (() => { action[1](...args); return true; })() : false));

export default {
    getJWT,
    getPulseJWE,
};
